import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import '../styles/navbar.css'
import '../styles/sub-navbar.css';
import {Menubar} from "primereact/menubar";
import {MenuItem, MenuItemOptions} from "primereact/menuitem";
import {useLocation, useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import {useUserInfo} from "../hooks/useUserInfo";
import {Api, OffersCountDto} from "../services/api";
import {useOffersCount} from "../hooks/swr/offer/useOffersCount";
import {Badge} from "primereact/badge";
import {useHeaderComponent} from "../hooks/useHeaderComponent";
import {useOfferCounts} from "../hooks/swr/offer/useOfferCounts";
import {mutate} from "swr";
import styled from "styled-components";
import {Button} from "primereact/button";
import {Menu} from "primereact/menu";

interface Props {

}

const NewSystem = styled.span`
  position: fixed;
  left: 10px;
  top: 25px;
  z-index: 100;
  font-size: 2rem;
  color: white;
`

const ActiveUser = styled.span`
  //position: fixed;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  right: 10px;
  top: 25px;
  z-index: 100;
  font-size: 1rem;
  color: white;
`

export const Navigation: React.FC<Props> = props => {
    const didMountRef = useRef(false);
    const {formatMessage: f} = useIntl();

    const offerSubModules = ['edit', 'tickets', 'deals', 'contracts'];
    const {weekPickerState, component} = useHeaderComponent();
    const {updateUserInfo} = useUserInfo();
    const {userInfo} = useUserInfo();
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const api = new Api();
    const offersOverlayMenuRef = useRef<any>(null);

    const [offerId, setOfferId] = useState<number>();

    const {
        data: offersCount,
        mutationKey: offersCountMutationKey
    } = useOffersCount(weekPickerState.weekNumber, weekPickerState.year, userInfo.authenticated && pathname.includes("offers"))

    const {data: offerCounts, mutationKey: offerCountsMutationKey} = useOfferCounts(offerId);

    const [offersCountState, setOffersCountState] = useState<OffersCountDto>()
    const [offerCountsState, setOfferCountsState] = useState<OffersCountDto>()

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }

    }, []);

    useEffect(() => {
        const hideOverlay = (event: MouseEvent) => {
            if (offersOverlayMenuRef.current) {
                offersOverlayMenuRef.current.hide(event);
            }
        }
        setTimeout(() => {
            const offersMenuItem = document.querySelector('#offers-menu-item') as HTMLElement | null;
            if (offersMenuItem) {

                offersMenuItem.addEventListener('mouseleave', hideOverlay)
            }

        }, 1000)

            return () => {
                const offersMenuItem = document.querySelector('#offers-menu-item') as HTMLElement | null;
                if(offersMenuItem)
                    offersMenuItem.removeEventListener('mouseleave', hideOverlay);
            }

    }, [userInfo.authenticated]);

    useEffect(() => {
        //In offers -> submodule
        if (pathname.includes('/offers') && offerSubModules.some(subModule => pathname.includes(subModule))) {
            const offerIdRegex = /\d+/;
            const match = pathname.match(offerIdRegex);
            const offerId = match && match[0];
            if (offerId && !isNaN(+offerId)) {
                setOfferId(+offerId);
            }
            mutate(offerCountsMutationKey);
        }
    }, [pathname]);

    useEffect(() => {
        setOffersCountState(offersCount);
    }, [offersCount]);

    useEffect(() => {
        setOfferCountsState(offerCounts);
    }, [offerCounts])


    const getMainMenuActiveClass = (module: string) => {
        return pathname.includes(module) ? 'active' : '';
    }

    const getSubMenuActiveClass = (module: string) => {
        return pathname.includes(module) ? 'active' : '';
    }

    const handleLogout = () => {
        api.api.logout().then(() => {
            navigate("/");
            updateUserInfo({
                authenticated: false,
                userId: undefined,
                role: undefined,
                username: undefined,
                names: undefined
            });
        });
    };

    const loginItems: MenuItem[] = [
        {
            label: f({id: "systemLogin"}),
            className: `nav-item `,
            command: () => navigate('/login')
        },
    ]

    const offersOverlayMenu: MenuItem[] = [
        {label: f({id: 'withDeal'}), command: () => navigate('/offers/withDeal')}, {
            label: f({id: 'withTicket'}),
            command: () => navigate('/offers/withTicket')
        }
    ]

    const mainItems: MenuItem[] = [
        {
            id: 'offers-menu-item',
            label: f({id: "offers"}),
            className: `nav-item ${!pathname.includes('reports') && getMainMenuActiveClass('/offers')}`,
            command: () => navigate('/offers/all')
        },
        {
            label: f({id: "sessions"}),
            className: `nav-item ${getMainMenuActiveClass('sessions')}`,
            command: () => navigate('/sessions/info')
        },
        {
            label: f({id: "reports"}),
            className: `nav-item ${getMainMenuActiveClass('reports')}`,
            command: () => navigate('/reports/offers')
        },
        {
            label: f({id: "accounting"}),
            className: `nav-item ${getMainMenuActiveClass('accounting')}`,
            command: () => navigate('/accounting/homeScreen')
        },
        {
            label: f({id: "dictionaries"}),
            className: `nav-item ${getMainMenuActiveClass('dictionaries')}`,
            command: () => navigate('/dictionaries/brokers')
        },
        {
            label: f({id: "administration"}),
            className: `nav-item ${getMainMenuActiveClass('administration')}`,
            command: () => navigate('/administration/users')
        },
        {label: f({id: "logOut"}), className: `nav-item`, command: () => handleLogout()}
    ]

    const getMenuItems = () => {
        if (!userInfo.authenticated || userInfo.shouldChangePassword) {
            return loginItems;
        }
        return mainItems;
    }

    const offerSubmenuItemTemplate = (module: 'all' | 'withDeal' | 'withTicket' | 'withContract' | 'forApproval', item: MenuItem, options: MenuItemOptions) => {
        const isSubModule = offerSubModules.some(subModule => pathname.includes(subModule));
        const countObject = isSubModule ? offerCountsState : offersCountState;

        let label;
        if (countObject && countObject[module])
            label = <span>{item.label}<Badge className={'ml-2'} value={countObject[module]}/></span>
        else
            label = <span>{item.label}</span>

        //@ts-ignore
        return <a onClick={item.command} role="menuitem" className="p-menuitem-link nav-link" aria-haspopup="false"
                  data-pc-section="action">
            <span className="p-menuitem-text" data-pc-section="label">{label}</span>
        </a>
    }

    const getSubItems = (): MenuItem[] => {
        if (!userInfo.authenticated || userInfo.shouldChangePassword) {
            return [];
        }

        if (pathname.includes('offers/create')) return [];

        if (pathname.includes('/offers') && !pathname.includes('reports') && offerSubModules.every(subModule => !pathname.includes(subModule))) {
            return [
                {
                    label: f({id: "all"}),
                    className: `nav-item ${getSubMenuActiveClass('all')}`,
                    command: () => navigate('offers/all'),
                    template: offerSubmenuItemTemplate.bind(undefined, 'all')
                },
                {
                    label: f({id: "withDeal"}),
                    className: `nav-item ${getSubMenuActiveClass('withDeal')}`,
                    command: () => navigate('offers/withDeal'),
                    template: offerSubmenuItemTemplate.bind(undefined, 'withDeal')
                },
                {
                    label: f({id: "withTicket"}),
                    className: `nav-item ${getSubMenuActiveClass('withTicket')}`,
                    command: () => navigate('offers/withTicket'),
                    template: offerSubmenuItemTemplate.bind(undefined, 'withTicket')

                },
                {
                    label: f({id: "withContract"}),
                    className: `nav-item ${getSubMenuActiveClass('withContract')}`,
                    command: () => navigate('offers/withContract'),
                    template: offerSubmenuItemTemplate.bind(undefined, 'withContract')

                },
                {
                    label: f({id: "forApproval"}),
                    className: `nav-item ${getSubMenuActiveClass('forApproval')}`,
                    command: () => navigate('offers/forApproval'),
                    template: offerSubmenuItemTemplate.bind(undefined, 'forApproval')
                },
            ];
        } else if (pathname.includes('/offers') && !pathname.includes('reports')) {
            const offerIdRegex = /\d+/;
            const match = pathname.match(offerIdRegex);
            var offerId = match && match[0];
            if (offerId == null)
                return [];

            return [
                {
                    label: f({id: "offer"}),
                    className: `nav-item ${getSubMenuActiveClass(`offers/${offerId}/edit`)}`,
                    command: () => navigate(`offers/${offerId}/edit`)
                },
                {
                    label: f({id: "deals"}),
                    className: `nav-item ${getSubMenuActiveClass(`offers/${offerId}/deals`)}`,
                    command: () => navigate(`offers/${offerId}/deals`),
                    template: offerSubmenuItemTemplate.bind(undefined, 'withDeal')
                },
                {
                    label: f({id: "tickets"}),
                    className: `nav-item ${getSubMenuActiveClass(`offers/${offerId}/tickets`)}`,
                    command: () => navigate(`offers/${offerId}/tickets`),
                    template: offerSubmenuItemTemplate.bind(undefined, 'withTicket')
                },
                {
                    label: f({id: "contracts"}),
                    className: `nav-item ${getSubMenuActiveClass(`offers/${offerId}/contracts`)}`,
                    command: () => navigate(`offers/${offerId}/contracts`),
                    template: offerSubmenuItemTemplate.bind(undefined, 'withContract')
                }
            ]
        } else if (pathname.includes('reports')) {
            return [
                {
                    label: f({id: "offers"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/offers`)}`,
                    command: () => navigate(`reports/offers`)
                },
                {
                    label: f({id: "deals"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/deals`)}`,
                    command: () => navigate(`reports/deals`)
                },
                {
                    label: f({id: "contracts"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/contracts`)}`,
                    command: () => navigate(`reports/contracts`)
                },
                {
                    label: f({id: "oldContracts"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/oldContracts`)}`,
                    command: () => navigate(`reports/oldContracts`)
                },
                {
                    label: f({id: "registryOffice"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/registryOffice/broker`)} ${getSubMenuActiveClass(`reports/registryOffice/brokerHouse`)}`,
                    command: () => navigate(`reports/registryOffice/brokerHouse`)
                },
                {
                    label: f({id: "brokerHouses"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/brokerHouses`)}`,
                    command: () => navigate(`reports/brokerHouses`)
                },
                {
                    label: f({id: "brokers"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/brokers`)}`,
                    command: () => navigate(`reports/brokers`)
                },
                {
                    label: f({id: "currencies"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/currencyRates`)}`,
                    command: () => navigate(`reports/currencyRates`)
                },
                {
                    label: f({id: "predefined"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/predefined`)}`,
                    command: () => navigate(`reports/predefined`)
                },
                {
                    label: f({id: "mega"}),
                    className: `nav-item ${getSubMenuActiveClass(`reports/mega`)}`,
                    command: () => navigate(`reports/mega`)
                },
            ]
        } else if (pathname.includes('administration')) {
            return [
                {
                    label: f({id: "users"}),
                    className: `nav-item ${getSubMenuActiveClass('users')}`,
                    command: () => navigate('administration/users')
                },
                // {
                //     label: f({id: "userRoles"}),
                //     className: `nav-item ${getSubMenuActiveClass('roles')}`,
                //     command: () => navigate('administration/roles')
                // }
            ]
        } else if (pathname.includes('dictionaries')) {
            return [
                {
                    label: f({id: "brokers"}),
                    className: `nav-item ${getSubMenuActiveClass('brokers')}`,
                    command: () => navigate('dictionaries/brokers')
                },
                {
                    label: f({id: "brokerHouses"}),
                    className: `nav-item ${getSubMenuActiveClass('broker-houses')}`,
                    command: () => navigate('dictionaries/broker-houses')
                },
                {
                    label: f({id: "companies"}),
                    className: `nav-item ${getSubMenuActiveClass('companies')}`,
                    command: () => navigate('dictionaries/companies')
                },
                {
                    label: f({id: "nsiCode"}),
                    className: `nav-item ${getSubMenuActiveClass('commodities')}`,
                    command: () => navigate('dictionaries/commodities')
                },
                {
                    label: f({id: "deliveryTimes"}),
                    className: `nav-item ${getSubMenuActiveClass('delivery-terms')}`,
                    command: () => navigate('dictionaries/delivery-terms')
                },
                {
                    label: f({id: "measurements"}),
                    className: `nav-item ${getSubMenuActiveClass('measurements')}`,
                    command: () => navigate('dictionaries/measurements')
                },
                {
                    label: f({id: "commissions"}),
                    className: `nav-item ${getSubMenuActiveClass('commissions')}`,
                    command: () => navigate('dictionaries/commissions')
                },
                {
                    label: f({id: "currencies"}),
                    className: `nav-item ${getSubMenuActiveClass('currencies')}`,
                    command: () => navigate('dictionaries/currencies')
                },
                // {
                //     label: f({id: "cpvCodes"}),
                //     className: `nav-item ${getSubMenuActiveClass('cpv-codes')}`,
                //     command: () => navigate('dictionaries/cpv-codes')
                // }

            ]
        } else if (pathname.includes("accounting")) {
            return [
                {
                    label: f({id: "contracts"}),
                    className: `nav-item ${getSubMenuActiveClass('homeScreen')}`,
                    command: () => navigate('accounting/homeScreen')
                },
                {
                    label: f({id: "guaranteeDeposits"}),
                    className: `nav-item ${getSubMenuActiveClass('guarantee-deposits')}`,
                    command: () => navigate('accounting/guarantee-deposits')
                }
            ]
        } else if (pathname.includes("sessions/info") || pathname.includes('sessions/demo') || pathname.endsWith('sessions/online')) {
            return [
                {
                    label: f({id: "sessions"}),
                    className: `nav-item ${getSubMenuActiveClass('sessions/info')}`,
                    command: () => navigate('sessions/info')
                },
                {
                    label: f({id: "onlineSessions"}),
                    className: `nav-item ${getSubMenuActiveClass('sessions/online')}`,
                    command: () => navigate('sessions/online')
                },
                {
                    label: f({id: "demoSession"}),
                    className: `nav-item ${getSubMenuActiveClass('sessions/demo')}`,
                    command: () => navigate('sessions/demo')
                }
            ]
        }

        return [];
    }

    const shouldRenderBackToSession = () => {
        let pathCondition = false;
        const baseCondition = userInfo.authenticated && !userInfo.shouldChangePassword && userInfo.liveSessionInfo && userInfo.userId === userInfo.liveSessionInfo.currentSessionOperatorId && userInfo.liveSessionInfo.exchangeSessionId && userInfo.liveSessionInfo.offerId;
        if (baseCondition) {
            if (userInfo.liveSessionInfo!.isOnline) {
                pathCondition = !pathname.includes(`/sessions/online/${userInfo.liveSessionInfo!.exchangeSessionId}`)
            } else {
                pathCondition = !pathname.includes(`/sessions/session/${userInfo.liveSessionInfo!.exchangeSessionId}`)
            }
        }

        return baseCondition && pathCondition;
    }

    const handleBackToSession = () => {
        if (shouldRenderBackToSession()) {
            if (userInfo.liveSessionInfo!.isOnline) {
                navigate(`/sessions/online/${userInfo.liveSessionInfo!.exchangeSessionId}/${userInfo.liveSessionInfo!.offerId}`);
            } else {
                navigate(`/sessions/session/${userInfo.liveSessionInfo!.exchangeSessionId}/${userInfo.liveSessionInfo!.offerId}`);
            }
        }
    }

    const handleMenuItemMouseOver = (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        const offersMenuItem = document.querySelector("#offers-menu-item");
        if (offersMenuItem && offersMenuItem.contains(target) && offersOverlayMenuRef.current) {
            offersOverlayMenuRef.current.show(event);
        }
    }

    return <>
        {/*<NewSystem>Нова Система</NewSystem>*/}
        <Menu model={offersOverlayMenu} popup ref={offersOverlayMenuRef}
              appendTo={(document.querySelector('#offers-menu-item') as HTMLElement)} className={'offers-menu-overlay'}
              style={{left: 0, top: '50px'}}/>
        <nav className={'navbar bg-primary fixed-top fixed-top-mainmenu'}>
            <div className="container">
                <a className="navbar-brand" onClick={() => navigate('/offers/all')} data-qa="homeLink">
                    <img src="/logo.svg" width="64" height="64" alt="SCE-Logo"/>
                </a>

                <ActiveUser>
                    <label>{userInfo.username}</label>
                    <label>{userInfo.names}</label>
                </ActiveUser>

                {shouldRenderBackToSession() ? <Button onClick={handleBackToSession}
                                                       className={'nav-item-session'}>{f({id: 'backToSession'})}</Button> : null}

                <Menubar model={getMenuItems()} className={'navbar-menu-bar'}
                         pt={{action: {className: 'nav-link'}, menuitem: {onMouseOver: handleMenuItemMouseOver}}}/>
            </div>
        </nav>

        {(userInfo.authenticated && !userInfo.shouldChangePassword) &&
            <nav className={'navbar navbar-expand-md navbar-light bg-white fixed-top fixed-top-submenu'}>
                <div className="container flex justify-content-space-between">
                    {component}
                    {getSubItems().length > 0 &&
                        <Menubar model={getSubItems()} className={'navbar-submenu-bar'}
                                 pt={{action: {className: 'nav-link'}}}/>
                    }
                </div>
            </nav>
        }
    </>
};
